import { render, staticRenderFns } from "./recommendList.vue?vue&type=template&id=45af0b6e&scoped=true&"
import script from "./recommendList.vue?vue&type=script&lang=js&"
export * from "./recommendList.vue?vue&type=script&lang=js&"
import style0 from "./recommendList.vue?vue&type=style&index=0&id=45af0b6e&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45af0b6e",
  null
  
)

export default component.exports